export const SportbetCurrency = "$";
export const SportbetLink = "https://www.sportsbet.com.au/";
export const SportbetAgeLimit = 18;

export const SportsbetMultiBuilderLink = "https://ad.doubleclick.net/ddm/clk/574497014;383834088;v";
export const SportsbetMultiH2HMWeb = "https://ad.doubleclick.net/ddm/clk/574046693;383157769;c";
export const SportsbetMultiH2HWeb = "https://ad.doubleclick.net/ddm/clk/574201684;383157766;s";
